module.exports = __webpack_public_path__ + "assets/img/guide.ac7ccd18.jpg";